import { forwardRef } from "react";

import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import ChevronDownIcon from "@/icons/ChevronDownIcon";
import ActivityHeader from "@/view/ActivityHeader";
import { rootCss, iconCss } from "./ActivityPanelTab.style";

const propTypes = {
  fitContent: PropTypes.bool,
  isArticle: PropTypes.bool,
  isStudent: PropTypes.bool,
  onClick: PropTypes.func,
};

/**
 * @typedef {Object} ActivityPanelTabProps
 * @property {boolean} [fitContent]
 * @property {boolean} [isArticle]
 * @property {boolean} [isStudent]
 * @property {() => void} [onClick]
 */

/** @type {React.ForwardRefExoticComponent<ActivityPanelTabProps & React.RefAttributes<HTMLButtonElement>>} */
const ActivityPanelTab = forwardRef(
  ({ fitContent = false, isArticle = true, isStudent, onClick }, ref) => {
    return (
      <Button
        onClick={onClick}
        flavor={Button.flavors.incognito}
        __cssFor={{ root: rootCss(!isStudent, fitContent) }}
        ref={ref}
      >
        <ActivityHeader isStudent={isStudent} isArticle={isArticle} />
        <ChevronDownIcon css={iconCss} />
      </Button>
    );
  },
);

ActivityPanelTab.propTypes = propTypes;

export default ActivityPanelTab;
